<label class='checkboxControl' [ngClass]="{'disabled': disabled}">
  <input type='checkbox' [(ngModel)]="checked" (change)="clickHandler($event)"/>
  <div>ΟΙ</div>
  <span class='indicator'></span>
</label>